import * as React from 'react';
import { NotificationBar } from '../../components/atoms/notifications/NotificationBar';
import './errorPage.module.scss';

export const ErrorPage = ({ message }) => {
    return (
        <div styleName="page">
            <NotificationBar type="warning" buttonLabel="ページをリロード" onClick={() => location.reload()}>
                {message}
            </NotificationBar>
        </div>
    );
};
